import { render, staticRenderFns } from "./PurchaseCardList.vue?vue&type=template&id=b5097094&scoped=true&"
import script from "./PurchaseCardList.vue?vue&type=script&lang=js&"
export * from "./PurchaseCardList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCardList.vue?vue&type=style&index=0&id=b5097094&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5097094",
  null
  
)

export default component.exports